import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const propTypes = {
  player: PropTypes.object,
  className: PropTypes.string,
};

export default function LoadingSpinner({ player, className }) {
  return (
    <div
      className={classNames(
        'video-react-loading-spinner',
        className
      )}
    >
      <div className="spinner-main">
        <div className="spinner-big" />
        <div className="spinner-small" />
      </div>
    </div>
  );
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';
